/* eslint-disable @typescript-eslint/naming-convention */
import ApiGateway from 'config/apiServiceApiGateway'
import { Get as OldAPIGet } from 'config/apiServiceConfig'
import {
  CategoryType,
  CategoryOldType,
  GetWimsConstantsType,
  ConstanstItemType,
  ProductAttributeOptionType,
  ProductAttributeTypeType,
  ProductTypeItemType,
  ProductUomType,
  StorageHandlingType,
} from '../@types/ProductAdd'

type GetCategoryByIdResponseType = {
  category_id: number
  category_name: string
  min_shelf_life_on_delivery: number
  min_shelf_life_on_receiving: number
  min_shelf_life_to_customer: number
}

export type GetCategoryQueryParamsType = {
  'pagination.page_index': number
  'pagination.page_size': number
  'pagination.sort'?: string
  'pagination.direction'?: 'asc' | 'desc'
  'filter.active'?: boolean
  'filter.name'?: string
}

export type GetPPNResponseType = {
  id: number
  ppn: number
}

export type GetProductAttributeOptionRequestType = {
  type: ProductAttributeTypeType
}

export const getCategoriesApi = (params: GetCategoryQueryParamsType) =>
  ApiGateway.Get<CategoryType[]>({
    url: '/wims/internal/v1/categories',
    params,
  })

export const getCategoryByIdApi = (id: number) =>
  OldAPIGet<GetCategoryByIdResponseType>({
    url: `/api/category/${id}`,
  })

export const getStorageHandlings = () =>
  ApiGateway.Get<ConstanstItemType[]>({
    url: `/wims/internal/v1/racks/storages`,
  })

export const getWimsConstants = () =>
  ApiGateway.Get<GetWimsConstantsType>({
    url: '/wims/internal/v1/constants',
  })

export const getPPNList = () =>
  OldAPIGet<{ data: GetPPNResponseType[] }>({
    url: '/api/ims/ppn/v1',
  })

export const getProductAttributeOptionApi = (params: GetProductAttributeOptionRequestType) =>
  ApiGateway.Get<ProductAttributeOptionType[]>({
    url: '/wims/internal/v1/products/attribute-options',
    params,
  })

export const getWimsProductTypes = () =>
  ApiGateway.Get<ProductTypeItemType[]>({
    url: '/wims/internal/v1/products/types',
  })

export type GetWimsProductUomQueryParamsType = {
  'filter.description'?: string
  'filter.active'?: boolean
  'filter.groups'?: string
  'filter.id'?: string
  'pagination.page_size': number
  'pagination.page_index': number
}

export const getWimsProductUoms = (params: GetWimsProductUomQueryParamsType) =>
  ApiGateway.Get<ProductUomType[]>({
    url: '/wims/internal/v1/products/uoms',
    params,
  })

export type GetWimsStorageHandlingsParamsType = Partial<{
  type?: string
  ids?: number[]
}>

export const getWimsStorageHandlings = (params?: GetWimsStorageHandlingsParamsType) => {
  const searchParams = new URLSearchParams()
  Object.entries(params ?? {}).forEach(([key, value]) => {
    if (!['ids'].includes(key) && value !== undefined && value !== null) {
      searchParams.append(key, String(value))
    }
  })
  params?.ids?.forEach((id) => {
    searchParams.append('ids', String(id))
  })
  const queryString = searchParams.toString()

  return ApiGateway.Get<StorageHandlingType[]>({
    url: `/wims/internal/v1/storage-handlings?${queryString}`,
  })
}

export const getCategoryOlds = () =>
  OldAPIGet<CategoryOldType[]>({
    url: '/api/categories/child',
  })
